export abstract class MtBase {
  Id?: string;
  ObjectType?: string;
  IdRefResource?: string;
}
